import React from 'react';
import saveAs from 'file-saver';
import { pdf } from '@react-pdf/renderer';
import { isMobile } from 'react-device-detect';
import { formatDateTimeMMDDpm } from '@mummssoftware/utils/formatters';
import { DashboardPDFDocument } from '../index';
export const printPDF = async (getDocument, patient) => {
  const doc = getDocument();
  const asPdf = pdf( /*#__PURE__*/React.createElement(React.Fragment, null));
  asPdf.updateContainer(doc);
  const blob = await asPdf.toBlob();

  if (isMobile) {
    saveAs(blob, `${patient === null || patient === void 0 ? void 0 : patient.firstName}${patient === null || patient === void 0 ? void 0 : patient.lastName}${patient === null || patient === void 0 ? void 0 : patient.patientNumber} - ${formatDateTimeMMDDpm(new Date())}.pdf`);
    return;
  }

  const blobURL = URL.createObjectURL(blob);
  const reactPdfIframe = document.querySelector('#react-pdf-iframe');

  if (reactPdfIframe) {
    document.body.removeChild(reactPdfIframe);
  }

  const iframe = document.createElement('iframe');
  iframe.id = 'react-pdf-iframe';
  iframe.style.display = 'none';
  iframe.src = blobURL;

  iframe.onload = () => {
    setTimeout(() => {
      iframe.focus();
      iframe.contentWindow && iframe.contentWindow.print();
    }, 1);
  };

  document.body.appendChild(iframe);
}; // print from a config and provide the data (formatted as {pdfTasksNotes: {}, etc.})
// ideal when printing from a widget and you already fetched your data

export const printComponents = (widgetConfig, printConfig, printData, patient, currentUser) => {
  const {
    rgHash,
    rgHashPrint,
    patientCertHistory,
    cpfNotes,
    cppNotesGlobal,
    pdfCarePlanProblems,
    patientActiveCPPTasks,
    pdfProgressNotes,
    pdfPSOComponents,
    pdfCertAppSnapshot,
    pdfMeasuresGraphImages,
    measuresGlobal,
    pdfMedications,
    pdfMedicationsNotes,
    pdfBereavNotes,
    pdfCareGiversInfo,
    historicalRows,
    jsonMeasures,
    pdfWeeklyTasks,
    includePdfTasksNotes,
    pdfTasksNotes,
    pdfFacesheetData
  } = printData;

  const getDoc = () => /*#__PURE__*/React.createElement(DashboardPDFDocument, {
    patient: patient,
    currentUser: currentUser,
    widgetConfig: widgetConfig,
    rgHash: rgHash,
    rgHashPrint: rgHashPrint,
    dashboardPrintConfig: printConfig,
    patientCertHistory: patientCertHistory,
    cpfNotes: cpfNotes,
    cppNotesGlobal: cppNotesGlobal,
    pdfCarePlanProblems: pdfCarePlanProblems,
    pdfProgressNotes: pdfProgressNotes,
    pdfPSOComponents: pdfPSOComponents,
    pdfCertAppSnapshot: pdfCertAppSnapshot,
    pdfMeasuresGraphImages: pdfMeasuresGraphImages,
    measuresGlobal: measuresGlobal,
    pdfMedications: pdfMedications,
    pdfMedicationsNotes: pdfMedicationsNotes,
    pdfBereavNotes: pdfBereavNotes,
    pdfCareGiversInfo: pdfCareGiversInfo,
    historicalRows: historicalRows,
    jsonMeasures: jsonMeasures,
    pdfWeeklyTasks: pdfWeeklyTasks,
    includePdfTasksNotes: includePdfTasksNotes,
    pdfTasksNotes: pdfTasksNotes,
    pdfFacesheetData: pdfFacesheetData
  });

  printPDF(getDoc, patient);
};